import { c as _c } from "react/compiler-runtime";
import { ArticleSEO } from '@src/components/sco/utilities/SEOProvider/ContentItemSEO/ArticleSEO';
import { ClarityExpertSEO } from '@src/components/sco/utilities/SEOProvider/ContentItemSEO/ClarityExpertSEO';
import { ClarityQuestionSEO } from '@src/components/sco/utilities/SEOProvider/ContentItemSEO/ClarityQuestionSEO';
import { ContentTrackSEO } from '@src/components/sco/utilities/SEOProvider/ContentItemSEO/ContentTrackSEO';
import { ContentTrackSectionSEO } from '@src/components/sco/utilities/SEOProvider/ContentItemSEO/ContentTrackSectionSEO';
import { ContentTrackStepSEO } from '@src/components/sco/utilities/SEOProvider/ContentItemSEO/ContentTrackStep';
import { GroupEventSEO } from '@src/components/sco/utilities/SEOProvider/ContentItemSEO/GroupEventSEO';
import { GroupRequestSEO } from '@src/components/sco/utilities/SEOProvider/ContentItemSEO/GroupRequestSEO';
import { LandingPageSEO } from '@src/components/sco/utilities/SEOProvider/ContentItemSEO/LandingPageSEO';
import { PodcastEpisodeSEO } from '@src/components/sco/utilities/SEOProvider/ContentItemSEO/PodcastEpisodeSEO';
import { ScoInvestorProfileSEO } from '@src/components/sco/utilities/SEOProvider/ContentItemSEO/ScoInvestorProfileSEO';
import { ScoPlaybookSEO } from '@src/components/sco/utilities/SEOProvider/ContentItemSEO/ScoPlaybookSEO';
import { ScoUserSEO } from '@src/components/sco/utilities/SEOProvider/ContentItemSEO/ScoUserSEO';
import { VideoListSEO } from '@src/components/sco/utilities/SEOProvider/ContentItemSEO/VideoListSEO';
import { VideoSEO } from '@src/components/sco/utilities/SEOProvider/ContentItemSEO/VideoSEO';
import { ContentItem } from '@src/contexts/ActiveContentContext';
import { Article, ClarityExpert, ClarityQuestion, ContentTrack, ContentTrackSection, ContentTrackStep, GroupEvent, GroupRequest, PodcastEpisode, ScoInvestorProfile, ScoPlaybook, ScoUser, VideoList, Video } from '@src/graphql-types';
import React from 'react';
export const ContentItemSEO = props => {
  const $ = _c(31);
  switch (props.item.__typename) {
    case "LandingPage":
      {
        const t0 = props.item as {
          title: string;
        };
        let t1;
        if ($[0] !== t0) {
          t1 = <LandingPageSEO landingPage={t0} />;
          $[0] = t0;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case "Article":
      {
        const t0 = props.item as Article;
        let t1;
        if ($[2] !== t0) {
          t1 = <ArticleSEO article={t0} />;
          $[2] = t0;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case "ContentTrack":
      {
        const t0 = props.item as ContentTrack;
        let t1;
        if ($[4] !== t0) {
          t1 = <ContentTrackSEO contentTrack={t0} />;
          $[4] = t0;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    case "ContentTrackStep":
      {
        const t0 = props.item as ContentTrackStep;
        let t1;
        if ($[6] !== t0) {
          t1 = <ContentTrackStepSEO contentTrackStep={t0} />;
          $[6] = t0;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
    case "ContentTrackSection":
      {
        const t0 = props.item as ContentTrackSection;
        let t1;
        if ($[8] !== t0) {
          t1 = <ContentTrackSectionSEO contentTrackSection={t0} />;
          $[8] = t0;
          $[9] = t1;
        } else {
          t1 = $[9];
        }
        return t1;
      }
    case "PodcastEpisode":
      {
        const t0 = props.item as PodcastEpisode;
        let t1;
        if ($[10] !== t0) {
          t1 = <PodcastEpisodeSEO podcastEpisode={t0} />;
          $[10] = t0;
          $[11] = t1;
        } else {
          t1 = $[11];
        }
        return t1;
      }
    case "VideoList":
      {
        const t0 = props.item as VideoList;
        let t1;
        if ($[12] !== t0) {
          t1 = <VideoListSEO videoList={t0} />;
          $[12] = t0;
          $[13] = t1;
        } else {
          t1 = $[13];
        }
        return t1;
      }
    case "Video":
      {
        const t0 = props.item as Video;
        let t1;
        if ($[14] !== t0) {
          t1 = <VideoSEO videoLesson={t0} />;
          $[14] = t0;
          $[15] = t1;
        } else {
          t1 = $[15];
        }
        return t1;
      }
    case "ClarityExpert":
      {
        const t0 = props.item as ClarityExpert;
        let t1;
        if ($[16] !== t0) {
          t1 = <ClarityExpertSEO clarityExpert={t0} />;
          $[16] = t0;
          $[17] = t1;
        } else {
          t1 = $[17];
        }
        return t1;
      }
    case "ClarityQuestion":
      {
        const t0 = props.item as ClarityQuestion;
        let t1;
        if ($[18] !== t0) {
          t1 = <ClarityQuestionSEO clarityQuestion={t0} />;
          $[18] = t0;
          $[19] = t1;
        } else {
          t1 = $[19];
        }
        return t1;
      }
    case "GroupRequest":
      {
        const t0 = props.item as unknown as GroupRequest;
        let t1;
        if ($[20] !== t0) {
          t1 = <GroupRequestSEO groupRequest={t0} />;
          $[20] = t0;
          $[21] = t1;
        } else {
          t1 = $[21];
        }
        return t1;
      }
    case "GroupEvent":
      {
        const t0 = props.item as unknown as GroupEvent;
        let t1;
        if ($[22] !== t0) {
          t1 = <GroupEventSEO groupEvent={t0} />;
          $[22] = t0;
          $[23] = t1;
        } else {
          t1 = $[23];
        }
        return t1;
      }
    case "ScoInvestorProfile":
      {
        const t0 = props.item as ScoInvestorProfile;
        let t1;
        if ($[24] !== t0) {
          t1 = <ScoInvestorProfileSEO investorProfile={t0} />;
          $[24] = t0;
          $[25] = t1;
        } else {
          t1 = $[25];
        }
        return t1;
      }
    case "ScoPlaybook":
      {
        const t0 = props.item as ScoPlaybook;
        let t1;
        if ($[26] !== t0) {
          t1 = <ScoPlaybookSEO playbook={t0} />;
          $[26] = t0;
          $[27] = t1;
        } else {
          t1 = $[27];
        }
        return t1;
      }
    case "ScoUser":
      {
        const t0 = props.item as ScoUser;
        let t1;
        if ($[28] !== t0) {
          t1 = <ScoUserSEO user={t0} />;
          $[28] = t0;
          $[29] = t1;
        } else {
          t1 = $[29];
        }
        return t1;
      }
    default:
  }
  let t0;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <></>;
    $[30] = t0;
  } else {
    t0 = $[30];
  }
  return t0;
};